var React = require('react');

function Tidal (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor"},React.createElement("path",{"d":"M13.612 7.304L7.306 1.006 1.001 7.303l6.301 6.311 6.31-6.306 6.306 6.298 6.304-6.3-6.3-6.304zM13.61 19.918l6.308 6.305 6.304-6.305-6.3-6.312zM32.531 1.006l-6.309 6.297 6.309 6.311 6.303-6.308z"})));
}

Tidal.defaultProps = {"width":"37.833","height":"25.221","viewBox":"1.001 1.002 37.833 25.221"};

module.exports = Tidal;

Tidal.default = Tidal;
